import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/data";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="section bg-secondary/40">
      <div className="container-page">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-7">
            <p className="label-eyebrow">What We Offer</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-forest mt-5 leading-[1.05]">
              Comprehensive care, <span className="italic text-terracotta">gently delivered.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-forest/70 text-lg leading-relaxed">
            From the first scan to the last consultation of menopause — every appointment is unhurried, every question welcome.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              data-testid={`service-card-${i}`}
              className="card-soft p-8 group flex flex-col"
              style={{ animation: `fade-up 0.7s ease-out ${i * 60}ms both` }}
            >
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-serif text-2xl md:text-[26px] leading-tight text-forest">{s.title}</h3>
                <ArrowUpRight className="w-5 h-5 text-sage transition-transform duration-300 group-hover:rotate-45 group-hover:text-terracotta shrink-0" strokeWidth={1.5} />
              </div>
              <p className="mt-4 text-forest/70 leading-relaxed">{s.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
